import { Directive, ElementRef, HostListener, AfterViewInit, Renderer2, Input } from '@angular/core';
import { CursorOption, cursorOptions } from '@app/shared/directives/cursor/cursor.model';

@Directive({
  selector: '[appCursor]'
})
export class CursorDirective implements AfterViewInit {
  public cursorElement;
  private defaultCursorOptions: CursorOption = cursorOptions;
  public cursorOptions: CursorOption;

  /*
   * Use this input to override the default options present in the model
   * if needed
   */
  @Input()
  options: CursorOption;

  constructor(private element: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.cursorOptions = { ...this.defaultCursorOptions, ...this.options };
    this.createCursor();
  }

  createCursor() {
    this.cursorElement = this.renderer.createElement('div');
    this.renderer.appendChild(this.element.nativeElement, this.cursorElement);
    this.cursorElement.addEventListener('mouseover', this.onMouseOver.bind(this), { passive: true });
    this.cursorElement.addEventListener('mousemove', this.onMouseMove.bind(this), { passive: true });
    this.cursorElement.addEventListener('mouseleave', this.onMouseLeave.bind(this), { passive: true });
  }

  @HostListener('mouseover')
  onMouseOver() {
    this.element.nativeElement.style.cursor = 'none';
    this.cursorElement.style.visibility = 'visible';
    this.setcursorElementStyle();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.element.nativeElement.style.cursor = 'normal';
    this.cursorElement.style.visibility = 'hidden';
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove({ pageX, pageY }) {
    // cursorElement center : width /2, height/2
    // cursor position in img
    const x = pageX - this.element.nativeElement.getBoundingClientRect().left - window.pageXOffset;
    const y = pageY - this.element.nativeElement.getBoundingClientRect().top - window.pageYOffset;
    this.renderer.setStyle(this.cursorElement, 'transform', 'translate3d(' + x + 'px ,' + y + 'px, 0)');
  }

  public setcursorElementStyle() {
    this.renderer.setStyle(this.cursorElement, 'position', 'absolute');
    this.renderer.setStyle(this.cursorElement, 'background-repeat', 'no-repeat');
    this.renderer.setStyle(this.cursorElement, 'top', '0');
    this.renderer.setStyle(this.cursorElement, 'width', `${this.cursorOptions.width}px`);
    this.renderer.setStyle(this.cursorElement, 'height', `${this.cursorOptions.height}px`);
    this.renderer.setStyle(this.cursorElement, 'background-image', this.cursorOptions.url);
  }
}
